module.exports = __webpack_public_path__ + "static/media/revery-2.0491969d.jpg";